import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const TimeLineBlock = (props) => {
    const { result } = props;
    const timeLineItems = result && result[0] && result[0].timeLineItems;
    const { innerWidth } = useSelector((state) => state.browserSize);

    const useGroupItemsByYear = (items) => {
        const [groupedItems, setGroupedItems] = useState(null);

        useEffect(() => {
            if (items && items.length > 0) {
                const grouped = [];
                const orderedYears = [];

                items.forEach(item => {
                    const year = new Date(item.date).getFullYear();
                    const index = orderedYears.indexOf(year);
                    if (index === -1) {
                        orderedYears.push(year);
                        grouped.push({ year: year, items: [item] });
                    } else {
                        grouped[index].items.push(item);
                    }
                });
                setGroupedItems(grouped);
            } else {
                setGroupedItems(null);
            }
        }, [items]);

        return groupedItems;
    };

    // Function to add class to all links within the description
    const addClassToLinks = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const links = doc.querySelectorAll('a');

        links.forEach((link) => {
            link.classList.add('timelineBlock__custom-link'); // Add your custom class to all <a> tags
        });

        return doc.body.innerHTML; // Return the modified HTML string
    };

    const groupedItems = useGroupItemsByYear(timeLineItems);

    return (
        <div className='timelineBlock grid-system grid-system-within-boundaries'>
            {groupedItems && groupedItems.map(({ year, items }) => (
                <div className='timelineBlock--container grid-full-width' key={year} >
                    {innerWidth > 600 &&
                        <p className='timelineBlock--container__year'>{year}</p>
                    }

                    <span className='timelineBlock--container__line'></span>
                    <div className='timelineBlock--ticket-container'>
                        {items.map((item, index) => (
                            <div className='timelineBlock--ticket-container__ticket' key={index}>
                                {
                                    <>
                                        {innerWidth > 600 && item.image && item.image.url &&
                                            <div className='timelineBlock--icon'>
                                                <img src={item.image.url} alt={item.image.alt} />
                                            </div>
                                        }

                                        <div className='timelineBlock--text-container'>
                                            {innerWidth <= 600 &&
                                                <p className='timelineBlock--container__year-mobile'>{year}</p>
                                            }
                                            <p className='timelineBlock--text-container__header'>{item.title}</p>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: addClassToLinks(item.description) // Process the description and add class to links
                                                }}
                                                className='timelineBlock--text-container__subheader'>
                                            </p>
                                        </div>
                                    </>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TimeLineBlock;
